<template>
	<Icon v-bind="$props">
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 388 512"
			class="icon-file-numbers"
		>
			<path
				opacity=".4"
				class="duotone"
				d="M249.4 0l69.2 69.2 69.2 69.2-110.7 0c-15.3 0-27.7-12.4-27.7-27.7L249.4 0z"
			/>
			<path
				class="duotone"
				d="M27.9 0C12.7 0 .3 12.4 .3 27.7l0 456.6C.3 499.6 12.7 512 27.9 512l332.1 0c15.3 0 27.7-12.4 27.7-27.7l0-345.9-110.7 0c-15.3 0-27.7-12.4-27.7-27.7L249.4 0 27.9 0zm61 376.1l0 54.7c0 7.6-6.2 13.8-13.8 13.8s-13.8-6.2-13.8-13.8l0-54.7c0-7.6 6.2-13.8 13.8-13.8s13.8 6.2 13.8 13.8zm54.2-68.5c7.6 0 13.8 6.2 13.8 13.8l0 109.3c0 7.6-6.2 13.8-13.8 13.8s-13.8-6.2-13.8-13.8l0-109.3c0-7.6 6.2-13.8 13.8-13.8zm81.8-95.5l0 218.7c0 7.6-6.2 13.8-13.8 13.8s-13.8-6.2-13.8-13.8l0-218.7c0-7.6 6.2-13.8 13.8-13.8s13.8 6.2 13.8 13.8zm54.2 40.8c7.6 0 13.8 6.2 13.8 13.8l0 164c0 7.6-6.2 13.8-13.8 13.8s-13.8-6.2-13.8-13.8l0-164c0-7.6 6.2-13.8 13.8-13.8z"
			/>
		</svg>
	</Icon>
</template>

<script>
import Icon, { props } from '../Icon'
export default {
	name: 'NumbersFileIcon',
	components: { Icon },
	props,
}
</script>
<style scoped>
svg path {
	fill: #54e56f !important;
}
</style>
